const state = {
  wifiState: {
    1: "初始",
    2: "正常",
    3: "禁用",
    4: "删除",
  }
}
const mutations = {

}
const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/wifi.js